import Vue from 'vue'
import App from './App.vue'
import Router from './router'
import VueSocketIO from 'vue-socket.io'
import '@/styles/fonts.css'
import '@/styles/variables.less'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faVolumeDown, faPlay, faPause, faMicrophone, faClipboardList } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

library.add(faVolumeDown, faPlay, faPause, faMicrophone, faClipboardList);

Vue.component('font-awesome-icon', FontAwesomeIcon);

Vue.config.productionTip = false

Vue.use(new VueSocketIO({
	debug: false,
	connection: 'https://voicy-speaker.herokuapp.com'
}))

new Vue({
	router: Router,
	render: function (h) { return h(App) }
}).$mount('#app')